document.addEventListener('DOMContentLoaded',function(){
  /* Keep the service choices near the top: hero + short clinic intro, then ways to work together. */
  var optionsSection=document.querySelector('.kwo');
  var firstConcernSection=document.querySelector('.kh-soft');
  if(optionsSection && firstConcernSection){
    var shopifyWrapper=optionsSection.closest('.shopify-section') || optionsSection;
    firstConcernSection.parentNode.insertBefore(shopifyWrapper,firstConcernSection);
  }
});